import { render, staticRenderFns } from "./ClientJbbfBaseBlankPage.vue?vue&type=template&id=7b0eb704&scoped=true&"
import script from "./ClientJbbfBaseBlankPage.vue?vue&type=script&lang=js&"
export * from "./ClientJbbfBaseBlankPage.vue?vue&type=script&lang=js&"
import style0 from "./ClientJbbfBaseBlankPage.vue?vue&type=style&index=0&id=7b0eb704&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0eb704",
  null
  
)

export default component.exports